import { HttpErrorResponse } from '@angular/common/http';

// Shared by the main app and the member portal: the error code the API puts in
// a 500 response (`{ ..., errorCode: "ERR-7F3A2C1B" }`, see ExceptionMiddleware).
// The same code finds the record on the admin System Logs page.

const CODE_PATTERN = /^ERR-[0-9A-F]{8}$/;

/** The error code carried by a 5xx response, or null. */
export function errorCodeOf(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse) || error.status < 500) return null;
  const code = (error.error as { errorCode?: unknown } | null)?.errorCode;
  return typeof code === 'string' && CODE_PATTERN.test(code) ? code : null;
}
